import React, { useState, useEffect, useCallback } from 'react';
// import Select from 'react-select';
// import Modal from '@mui/material/Modal';
// import PropTypes from 'prop-types';
// import { styled } from '@mui/material/styles';
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
// import {Container,Form,FormGroup,ModalFooter, Modal, ModalBody, ModalHeader,Row, Col,Label,Input,Nav,NavItem,NavLink, Placeholder } from 'reactstrap';
import './index.scss';
import toastr from 'toastr';
// import DatePicker from 'react-datepicker';
// import { LuTextSearch } from "react-icons/lu";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from 'react-redux';
import { showCrProj, hideCrProj } from '../redux/ctrl/ctrlActions';
import { useSelector } from 'react-redux';
import getDt from '../../utils';
import { getDtfrmt, fetchProductsById } from '../../utils';
import { showHideElem, fetchUsers, debounce } from '../../utils';
import { showLoader, refreshApp } from '../redux/ctrl/ctrlActions';
import Loader from '../loader';
import { createProject, fetchADNAct, quoteSearchStart, clearQuoteSearch } from '../redux/project/projActions';
import UpdateProject from './updProj';
import TextInput from '../shared/TextInput';
// import DateInput from '../shared/Dateinput';
import SelectInput from '../shared/Selectinput';
// import SrchAD from '../shared/SrchAD';
import ButtonC from '../shared/ButtonC';
import HOC from '../HOC/HOC';
import gifLoader from '../../assets/images/load.gif';
// import {AiOutlinePlusCircle} from 'react-icons/ai';
import CustomTooltip from '../userProjects/customTooltip';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';

const disb = false;

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
    // cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const CreateProject = (props) => {

  const [dueDate, setDueDate] = useState(null);
  const [crDate, setcrDate] = useState(new Date());
  let errCnt = 0;
  const ctrlState = useSelector((state) => state.ctrl);
  const profileState = useSelector((state) => state.profile);
  const quoteSearchResults = useSelector((state) => state.project.quoteSearchResults);
  const [nctrl, setNctrl] = useState(ctrlState)
  const sctrl = { ...nctrl };
  //const sctrl = []
  const [newProj, setNewProj] = useState({ endDest: 'US', project_status: 'OPEN' });
  const [searchQuote, setSearchQuote] = useState({});
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [showADSel, setshowADSel] = useState(false);
  const [showADSel1, setshowADSel1] = useState(false);
  const [users, setUsers] = useState(null);
  const [user, setUser] = useState(null);
  const [showSrchSel, setShowSrchSel] = useState(false);
  const [lpm, setLpm] = useState(null);
  const [lpe, setLpe] = useState(null);
  const TINP = useCallback(HOC(TextInput, disb), []);
  //const DINP = HOC(DateInput,disb);
  const SINP = useCallback(HOC(SelectInput, disb), []);
  const BtnC = useCallback(HOC(ButtonC, disb), []);
  const [focused, setFocused] = useState(false);
  const { t, i18n } = useTranslation();


  useEffect(() => {
    if (quoteSearchResults?.package) {
      props.handleQuoteSearch(quoteSearchResults.package)
    }
    if (quoteSearchResults?.message) {
      toastr.error(t(quoteSearchResults.message))
      props.clearSearch()
    }
  }, [quoteSearchResults])


  // call setSearchQuote({}) if props.advanceSearchFields object is empty
  // useEffect(()=>{
  //   if(props.advanceSearchFields && Object.keys(props.advanceSearchFields).length === 0){
  //     setSearchQuote({})
  //   }
  // }, [props.advanceSearchFields]) 

  useEffect(() => {

    const keyDownHandler = event => {
      if (event.key === 'Escape') {
        //event.preventDefault();

        setUsers(null);
        setShowSrchSel(false);
        setshowADSel(false);
        setshowADSel1(false);
        showHideElem('adname_loader', 'hide');
        showHideElem('adname_loader1', 'hide');
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  const onFocus = () => setFocused(true)
  const onBlur = () => setFocused(false)

  const closecSelD = () => {
    setTimeout(function () {
      setShowSrchSel(false);
    }, 500)
  }

  const ShowADNameSugg = async (event, val) => {
    if (event.key !== 'Escape') {
      const inp = event.target;
      setUser(null);
      let unfErr = '';
      inp.setCustomValidity('');
      if (inp.value.length >= 0) {
        inp.style.border = '1px solid #ced4da';
      }
      if (inp.value.length >= 3) {
        showHideElem(val.hideloader, 'show');
        const users = await fetchUsers(inp.value);
        if (users === 403) {
          dispatch(refreshApp(true))
        }
        if (users !== null && users !== 403 && users !== undefined && users.length > 0) {
          setUsers(users);
          if (val.field === 'lead_project_manager') {
            setshowADSel(true)
            setLoadingLpm(false);
            // setLpm(lpm)
            showHideElem(val.hideloader, 'hide');
          }
          else if (val.field === 'lead_project_engineer') {
            setshowADSel1(true)
            setLoadingLpe(false);
            // setLpe(lpe);
            showHideElem(val.hideloader, 'hide');
            //setLpe(inp.value)                     
          }

        } else {
          unfErr = '**' + inp.value + ' Not Found.'
          setUsers(null);
          setshowADSel(false);
          setLoadingLpm(false);
          setLoadingLpe(false);
          showHideElem(val.hideloader, 'hide');
        }
      } else {
        setshowADSel(false);
        setLoadingLpm(false);
        setLoadingLpe(false);
        showHideElem(val.hideloader, 'hide');
      }
      const tempErrors = { ...errors };
      if (unfErr !== '') {
        tempErrors[val.field] = unfErr;
      } else {
        delete tempErrors[val.field];
      }
      setErrors(tempErrors);
    }
  }

  const setCuser = (props) => {
    //{dispName:user.displayName, field:'lead_project_manager',loader:'adname_loader'}
    /*const tempUsers = [...users];
    let selUser;
    tempUsers.forEach((elem) => {
        if (elem.displayName === displayName) {
            selUser = elem;
        }
    });*/
    document.getElementById(props.field).value = props.dispName;//||selUser.givenName;
    //setUser(selUser);
    setUser(props.dispName)
    setshowADSel(false)
    setshowADSel1(false)
    showHideElem(props.loader, 'hide');
    setUsers(null);
  }



  const applyDebounce = useCallback(debounce(ShowADNameSugg), []);

  const closeAD = () => {
    setTimeout(function () {
      setshowADSel(false);
      //showHideElem('adname_loader1', 'hide');
      //showHideElem('adname_loader', 'hide');
    }, 200)
  }
  const valFields = (values) => {
    const errors = {}
    if (!values.project_name || values.project_name === undefined) {
      errors.project_name = "**Project Name is required";
      errCnt += 1;
    }
    if (!values.tier || values.tier === undefined) {
      errors.tier = "**Tier is required";
      errCnt += 1;
    }
    /*if (!values.end_user_cust || values.end_user_cust === undefined ){
        errors.end_user_cust = "**End User Customer is required";
        errCnt+=1;            
    }
    if (!values.project_manager){
        errors.project_manager = "**Project Manager is required";
        errCnt+=1;            
    }        
    if (!values.world_area){
        errors.world_area = "**World area is required";
        errCnt+=1;            
    }*/
    setErrors(errors);
  }
  // useEffect(()=>
  // {
  //     console.log(nctrl.showNewProj,"useeffect")
  // },[nctrl]
  // )
  const handleCrProj = (val) => {
    // console.log("dffgg")
    sctrl.showNewProj = val
    setNctrl(sctrl)
    dispatch(showCrProj(sctrl))
  }

  const handleClose = (val, reason) => {

    if ("backdropClick" === reason) {
      return false;
    }

    sctrl.showNewProj = val;
    setNewProj({ endDest: 'US', project_status: 'OPEN' })
    setNctrl(sctrl);
    setErrors({})
    setLpm("");
    setLpe("");
    setUsers(null);
    setShowSrchSel(false);
    setshowADSel(false);
    setshowADSel1(false);
    showHideElem('adname_loader', 'hide');
    showHideElem('adname_loader1', 'hide');
    dispatch(hideCrProj(nctrl))
  }

  const handleChange = (e) => {
    if (e.target !== undefined) {
      newProj[e.target.id] = e.target.value;
    }
  }

  const handleSearchFields = (e) => {
    setSearchQuote({ ...searchQuote, [e.target.id]: e.target.value })
  }

  const handleSearch = (e) => {
    //  e.preventDefault();  
    dispatch(quoteSearchStart(searchQuote))
    props.setIsOpenAdvanced(false);
    props.setAdvanceSearchFields(searchQuote)
    setSearchQuote({})
  }

  const createProj = async (e) => {

    //e.preventDefault();        
    var currentdate = new Date();
    newProj.due_date = getDt(dueDate);
    newProj.start_date = getDt(currentdate);
    newProj.last_mod_date = getDt(currentdate);
    newProj.created_by = profileState.email;
    newProj.owner_name = profileState.givenName + " " + profileState.familyName;
    newProj.lead_project_manager = lpm;
    newProj.lead_project_engineer = lpe;
    newProj.world_area = document.getElementById('world_area').value;
    //newProj.project_bg_info=document.getElementById('project_bg_info').value;
    valFields(newProj);

    if (errCnt === 0) {
      const productInfo = newProj.project_number ? await fetchProductsById(newProj.project_number) : []

      if (productInfo === 403) {
        dispatch(refreshApp(true))
      }
      if (Array.isArray(productInfo) && productInfo.length) {
        toastr.error(t('This Project Number already exists.'))
      }
      if (Array.isArray(productInfo) && !productInfo.length) {
        dispatch(showLoader(true))
        const crProj = {
          project_name: newProj.project_name,
          owner_name: profileState.givenName + " " + profileState.familyName,
          //master_prj: "N",
          crm_opp_num: newProj.crm_opp_num,
          //sold_to_cust: newProj.sold_to_cust,
          //end_user_cust: newProj.end_user_cust,
          //end_dest: newProj.end_dest?newProj.end_dest :'US',
          //internal_qte_num: newProj.internal_qte_num,
          //endcust_prjref: newProj.cus_prj_ref_num,
          project_status: newProj.project_status,
          //due_date: newProj.due_date,
          lead_project_engineer: newProj.lead_project_engineer,
          lead_project_manager: newProj.lead_project_manager,
          project_number: newProj.project_number,
          //epc: newProj.epc,
          last_mod_date: newProj.last_mod_date,
          parent_project: newProj.parent_project,
          operating_unit: newProj.world_area,
          pdl_project_name: newProj.pdl_project_name,
          project_bg_info: newProj.project_bg_info,
          //master_project: newProj.master_project,
          //sub_project: newProj.sub_project,
          //currency: newProj.currency,
          //pricing_region: newProj.pricing_region,
          //pricing_date: newProj.pricing_date,
          //pricelist: newProj.pricelist,
          created_by: newProj.created_by,
          start_date: newProj.start_date,
          world_area: newProj.world_area,
          //cus_prj_ref_num: newProj.cus_prj_ref_num,
          tier: newProj.tier,
          enabled_flag: "Y",
          favorite: "N",
          search: 'email'

        }
        sctrl.showNewProj = false;
        setNctrl(sctrl)
        setNewProj({ endDest: 'US', project_status: 'OPEN' })
        setLpm("");
        setLpe("");
        // console.log(crProj)
        dispatch(createProject(crProj))
      }
    }


  }
  const handleBackdropClick = (event) => {
    //these fail to keep the modal open
    event.stopPropagation();
    return false;
  };



  //Lpm select Asynchronous function

  const [openLpm, setOpenLpm] = useState(false);
  const [optionsLpm, setOptionsLpm] = useState([]);
  const [loadingLpm, setLoadingLpm] = useState(false);

  useEffect(() => {
    if (!openLpm) {
      setOptionsLpm([]);
    }
  }, [openLpm]);

  useEffect(() => {
    if (lpm) {
      if (lpm.length >= 3 && openLpm) {
        setLoadingLpm(true);
        setOpenLpm(false);
        setTimeout(() => {
          setOpenLpm(true);
        }, 100);

      }
    }
    if (!lpm) {
      setLoadingLpm(false);
    }
  }, [lpm]);

  useEffect(() => {
    if (showADSel && users) {
      setOptionsLpm([...users]);
    }
    if (!showADSel || !openLpm) {
      setOptionsLpm([]);
    }
  }, [showADSel, openLpm, users])


  const handleChangeLpm = (e) => {
    if (e && e.displayName) {
      setLpm(e.displayName);
    }
    if (typeof e === 'string') {
      setLpm(e);
    }
    if (e && e.key === 'Enter') {
      setLoadingLpm(false);
      setOpenLpm(false);
    }
    if (e == null) {
      setLpm(null);
    }
    setOptionsLpm([]);
    setshowADSel(false);
  }




  //Lpm select Asynchronous function




  //Lpe select Asynchronous function

  const [openLpe, setOpenLpe] = useState(false);
  const [optionsLpe, setOptionsLpe] = useState([]);
  const [loadingLpe, setLoadingLpe] = useState(false);

  useEffect(() => {
    if (!openLpe) {
      setOptionsLpe([]);
    }
  }, [openLpe]);

  useEffect(() => {
    if (lpe) {
      if (lpe.length >= 3 && openLpe) {
        setLoadingLpe(true);
        setOpenLpe(false);
        setTimeout(() => {
          setOpenLpe(true);
        }, 100);

      }
    }
    if (!lpe) {
      setLoadingLpe(false);
    }
  }, [lpe]);

  useEffect(() => {
    if (showADSel1 && users) {
      setOptionsLpe([...users]);
    }
    if (!showADSel1 || !openLpe) {
      setOptionsLpe([]);
    }
  }, [showADSel1, openLpe, users])

  const handleChangeLpe = (e) => {
    if (e && e.displayName) {
      setLpe(e.displayName);
    }
    if (typeof e === 'string') {
      setLpe(e);
    }
    if (e && e.key === 'Enter') {
      setLoadingLpe(false);
      setOpenLpe(false);
    }
    if (e == null) {
      setLpe(null);
    }
    setOptionsLpe([]);
    setshowADSel1(false);
  }

  //Lpe select Asynchronous function
  const inputToSetSize = ['asynchronous-lead_project_manager', 'asynchronous-lead_project_engineer'];

  useEffect(() => {
    if (nctrl.showNewProj) {
      setTimeout(() => {
        inputToSetSize.map((id) => {
          if (document.getElementById(id)) {
            document.getElementById(id).setAttribute("maxlength", "240");
          }
        })
      }, 1000)
    }
  }, [nctrl.showNewProj])

  return (
    <>
      {/* <Loader/>   */}
      {/*  advance searchNew Project Dialog */}
      <Dialog open={props.isOpenAdvanced} onClose={() => props.setIsOpenAdvanced(false)} id="create-PRJ" className="create-project muiForm-Modal" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title">
        <DialogTitle className="model-title mb-0" id="draggable-dialog-title"> {t('Advanced Search')}</DialogTitle>
        <DialogContent>

          <Grid container className="marginRow muiForm mb-2 pt-3" spacing={1.4}>
            <Grid item md={12} xs={12}>
              <TextField
                size='small'
                label={t('MyProject Workspace Quote Number')}
                name='quote_number'
                id='quote_number'
                type='text'
                inputProps={{ maxLength: 240 }}
                onChange={(e) => handleSearchFields(e)}
                value={searchQuote.quote_number || ''}
              />
            </Grid>
            {/* <Grid item md={12} xs={12}>
                                 <TextField
                                size='small'
                                label={t('Project Name')}
                                name='project_name'
                                id='project_name'
                                type='text'
                                inputProps={{ maxLength: 240 }}
                                onChange={(e) => handleSearchFields(e)}
                                value={searchQuote.project_name || ''}
                              />
                              </Grid> */}
            <Grid item md={12} xs={12}>
              <TextField
                size='small'
                label={t('Package Name')}
                name='package_name'
                id='package_name'
                type='text'
                inputProps={{ maxLength: 240 }}
                onChange={(e) => handleSearchFields(e)}
                value={searchQuote.package_name || ''}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='model-actions'>
          <Button onClick={() => props.setIsOpenAdvanced(false)} className="cnbtn btn btn-outline-success" variant="outlined" style={{ "marginRight": "5px" }}>
            {t('Cancel')}
          </Button>
          <Button disabled={Object.keys(searchQuote).length === 0 ||
            Object.values(searchQuote).every(value => !value)} className="sbtn btn btn-secondary right-space" variant="contained" color="success" onClick={e => handleSearch(e)} >
            {t('Search')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* advance search popup end  */}
      <UpdateProject />
      <div>
        {/*<Button className="sbtn0"/*className='btnc'*/ /*id='crPrjId' onClick={()=> handleCrProj(true)}>+ Create Project</Button>*/}
        <BtnC className="sbtn0 success-btn btn" id='crPrjId' onClick={() => handleCrProj(true)} label={'+ ' + t('Create Project')} disabled={profileState.capb.findIndex((o) => o.PWSCRPRJ === 'Y') >= 0 ? false : true} />
        {/*<label htmlFor='crPrjId'> <AiOutlinePlusCircle className="cmnbtn1" data-toggle="tooltip" data-placement="top" title="Create Project"/> </label>*/}
      </div>

      <Dialog open={nctrl.showNewProj} onClose={() => { if (showADSel || showADSel1) { setshowADSel(false); setshowADSel1(false); } else { handleClose(false) } }} id="create-PRJ" className="create-project muiForm-Modal" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title">
        <DialogTitle className="model-title mb-0" id="draggable-dialog-title"> {t('Create new Project')}</DialogTitle>
        <DialogContent>

          <Grid container className="marginRow muiForm mb-2 pt-3" spacing={1.4}>
            <Grid item md={12} xs={12}>

              <TextField label={t('Internal Project Name')}
                size='small'
                name="project_name" id="project_name" type="text" inputProps={{ maxLength: 240 }}
                onChange={(e) => handleChange(e)}
                required error={errors.project_name ? true : false} />
              {/* <p className="text-danger">{errors.project_name}</p> */}

            </Grid>

            <Grid item md={12} xs={12} className="project-number-div">

              <TextField onFocus={onFocus} onBlur={onBlur} label={t('Project Number')}
                size='small' name="project_number" id="project_number" type="text"
                inputProps={{ maxLength: 240 }} onChange={(e) => handleChange(e)} />
              <div hidden={focused} className='toolTip'>
                <CustomTooltip field='4' text={t('MyProject Workspace ID will default if left blank')} width='290px' height='28px'
                />
              </div>

            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                select
                name="project_status"
                id="project_status"
                label={t('Project Status')}
                size='small'
                value={newProj.project_status}
                inputProps={{ maxLength: 240 }}
                onChange={(e) => { setNewProj({ ...newProj, project_status: e.target.value }) }}
              >
                {sctrl.projStatus.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField> </Grid>

            <Grid item md={12} xs={12}>

              <Autocomplete
                id="asynchronous-lead_project_manager"
                freeSolo
                open={openLpm}
                onOpen={() => {
                  setOpenLpm(true);
                }}
                onClose={() => {
                  setOpenLpm(false);
                }}
                isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                getOptionLabel={(option) => option.displayName || ''}
                onChange={(event, e) => handleChangeLpm(e)}
                defaultValue={{ displayName: lpm }}
                options={optionsLpm}
                loading={loadingLpm}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t('Lead Project Manager')}
                    name="lead_project_manager"
                    id="lead_project_manager"
                    size="small"
                    defaultValue={lpm}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleChangeLpm(e);
                      }
                    }}
                    onChange={(e) => setLpm(e.target.value)}
                    onKeyUp={(e) => {
                      if (lpm) {
                        applyDebounce(e, {
                          // hideloader: "adname_loader",
                          field: "lead_project_manager",
                        })
                      }
                    }

                    }
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingLpm ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>





            {/* 

                     <Grid item md={12} xs={12}> 
                      
                        <div style={{position: "relative", zIndex: "11" }}>

                        <TextField size='small' 
                                    label="Lead Project Manager"                                     
                                    name='lead_project_manager' id='lead_project_manager' type='text' 
                                    inputProps={{ maxLength: 240 }}
                                        value={lpm} onChange={(e) => e.target.value} onKeyUp={(e) => applyDebounce(e, { hideloader: 'adname_loader', field: 'lead_project_manager' })} />
     <img src={gifLoader} id='adname_loader' alt='loading' className='adname-gif-loader' />
                                {showADSel &&
                                    <div className='search-sugg-sel-ad' id='search-sugg-sel-type'>
                                        {users !== null && users !== undefined && users.map((user, index) =>
                                            <div className="search-sugg-elem" key={index}>
                                                <label onClick={() => setCuser({dispName:user.displayName, field:'lead_project_manager',loader:'adname_loader'})}>{user.displayName}</label>
                                            </div>
                                        )}
                                    </div>}
                            </div>
                    
                     
                      </Grid>

                       */}

            <Grid item md={12} xs={12}>

              <Autocomplete
                id="asynchronous-lead_project_engineer"
                freeSolo
                open={openLpe}
                onOpen={() => {
                  setOpenLpe(true);
                }}
                onClose={() => {
                  setOpenLpe(false);
                }}
                isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                getOptionLabel={(option) => option.displayName || ''}
                onChange={(event, e) => handleChangeLpe(e)}
                defaultValue={{ displayName: lpe }}
                options={optionsLpe}
                loading={loadingLpe}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t('Lead Project Engineer')}
                    name="lead_project_engineer"
                    id="lead_project_engineer"
                    size="small"
                    defaultValue={lpe}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleChangeLpe(e);
                      }
                    }}
                    onChange={(e) => setLpe(e.target.value)}
                    onKeyUp={(e) => {
                      if (lpe) {
                        applyDebounce(e, {
                          // hideloader: "adname_loader",
                          field: "lead_project_engineer",
                        })
                      }
                    }

                    }
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingLpe ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>





            {/* 
                     <Grid item md={12} xs={12}> 
                     
                     <div style={{position: "relative", zIndex: "10" }}>
                    
                                    <TextField size='small' color="success" label="Lead Project Engineer" 
                                     name='lead_project_engineer' id='lead_project_engineer' type='text' 
                                     inputProps={{ maxLength: 240 }}
                                        defaultValue={lpe} onChange={(e) => handleChange(e)} onKeyUp={(e) => applyDebounce(e, { hideloader: 'adname_loader1', field: 'lead_project_engineer' })} />
                       
                                <img src={gifLoader} id='adname_loader1' alt='loading' className='adname-gif-loader' />
                                {showADSel1 &&
                                    <div className='search-sugg-sel-ad' id='search-sugg-sel-type'>
                                        {users !== null && users !== undefined && users.map((user, index) =>
                                            <div className="search-sugg-elem" key={index}>
                                                <label onClick={() => setCuser({dispName:user.displayName, field:'lead_project_engineer',loader:'adname_loader1'})}>{user.displayName}</label>
                                            </div>
                                        )}
                                    </div>
                                }                                
                            </div>                                                                  
                               
                     
                     
                     
                       </Grid> 
                       */}

            <Grid item md={12} xs={12}>
              <TextField
                disabled
                size='small'
                label={t('Created Date')}
                variant='outlined'
                color='success'
                name='start_date' id="start_date" type='text' inputProps={{ maxLength: 100 }}
                defaultValue={getDtfrmt(new Date())}
              />

            </Grid>

            <Grid item md={12} xs={12}>          <TextField label={t('Business Unit')}
              size='small' name='world_area'
              id='world_area' type='text' inputProps={{ maxLength: 240 }} disabled={true}
              defaultValue={profileState?.bu} /> </Grid>

            <Grid item md={12} xs={12}>                <TextField size='small' label={t('Project Data Link Project Name')}
              name='pdl_project_name' id='pdl_project_name' type='text' inputProps={{ maxLength: 240 }}
              onChange={(e) => handleChange(e)} /> </Grid>



            <Grid item md={12} xs={12}>
              <TextField
                size='small'
                label={t('CRM Opportunity ID')}
                variant='outlined'
                color='success'
                name='crm_opp_num'
                id='crm_opp_num'
                type='text'
                inputProps={{ maxLength: 15, inputMode: 'numeric', pattern: '[0-9]*' }}
                onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) e.preventDefault(); }}
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item md={12} xs={12}>
              <TextField
                select
                required
                size='small'
                label={t('Tier')}
                variant='outlined'
                color='success'
                name='tier'
                id='tier'
                error={errors.tier ? true : false}
                onChange={(e) => { newProj['tier'] = e.target.value; }}
              >
                {[1, 2, 3, 4, 5].map((val) => (
                  <MenuItem key={val} value={val}>{val}</MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item md={12} xs={12}>        <TextField multiline rows={2}
              size='small' label={t('Project Background Information')}
              inputProps={{ maxlength: 240 }}
              // value={newProj['project_bg_info']}
              name='project_bg_info' id='project_bg_info' type='textarea'
              onChange={(e) => handleChange(e)} />  </Grid>
          </Grid>


        </DialogContent>
        <DialogActions className='model-actions'>
          <Button className="cnbtn btn btn-outline-success" variant="outlined" onClick={(e) => handleClose(false)} style={{ "marginRight": "5px" }}>
            {t('Cancel')}
          </Button>
          <Button className="sbtn btn btn-secondary right-space" variant="contained" color="success" onClick={(e) => createProj(e)}>
            {t('Save')}
          </Button>
        </DialogActions>
      </Dialog>


    </>
  )
}

export default CreateProject;